import config from '../igglo_config';

let initInProgress = false;
let zendeskInitialized = false;
let pendingZendeskAPICalls = [];

function executeZendeskAPICall(call, params) {
  window.zE('webWidget', call, ...params);
}

function onceZendeskHasLoaded() {
  zendeskInitialized = true;
  pendingZendeskAPICalls.forEach(([fn, params]) => executeZendeskAPICall(fn, params));
  pendingZendeskAPICalls = [];
}

export function init() {
  if (!window.zE && !initInProgress) {
    initInProgress = true;

    window.zESettings = {
      webWidget: {
        contactOptions: { enabled: true }
      }
    };

    const script = document.createElement('script');
    script.async = true;
    script.setAttribute('charset', 'utf-8');
    script.id = 'ze-snippet';
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${config.zendeskChatKey}`;
    script.type = 'text/javascript';

    script.addEventListener('load', onceZendeskHasLoaded);

    document.body.appendChild(script);
  }
}

function noopFilter() { return true }

function callZendeskApi(call, extraFilters, triggerInit, ...params) {
  if (triggerInit) {
    init();
  }

  if (zendeskInitialized) {
    executeZendeskAPICall(call, params);
  } else {
    pendingZendeskAPICalls = pendingZendeskAPICalls
      .filter(([queued]) => (queued !== call)) // Dedupe calls
      .filter(extraFilters)
      .concat([[call, params]]);
  }
}

// If we are going to show the widget, there is no point in hiding it before.
export function hide() { callZendeskApi('hide', ([call]) => (call !== 'show'), false) }

// If we are going to hide the widget, there is no point in showing it before.
export function show() { callZendeskApi('show', ([call]) => (call !== 'hide'), true) }

export function identify(user, triggerInit = true) {
  if (user.name && user.email) {
    callZendeskApi('identify', noopFilter, triggerInit, user);
    callZendeskApi('prefill', noopFilter, triggerInit, {
      name: {
        value: user.name
      },
      email: {
        value: user.email
      }
    });
  }
}
